module.exports = "https://bicocca-network.servercdn.it/static/img/inchieste.jpg?13347155021054fb78a2f75dbbfe3328";